<template>
  <div class="document-list">
    <!-- Cabeçalho manual - Apenas exibido quando não está em modo mini -->
    <v-layout v-if="!mini" class="document-list-header" row wrap align-center justify-start>
      <v-flex xs1 xl1 class="header-col ordem text-center"
              style="max-width: 8%; flex-basis: 8%; padding-left: 6px !important;">Ordem
      </v-flex>
      <v-flex xs4 xl4 class="header-col documento text-center"
              style="max-width: 35%; flex-basis: 35%; padding-left: 6px !important;">Documento
      </v-flex>
      <v-flex xs3 xl3 class="header-col usuario text-center"
              style="max-width: 22%; flex-basis: 22%; padding-left: 6px !important;">Usuário
      </v-flex>
      <v-flex xs2 xl2 class="header-col numero text-center"
              style="max-width: 17%; flex-basis: 17%; padding-left: 6px !important;">Setor Criado
      </v-flex>
      <v-flex xs2 xl2 class="header-col criado text-center"
              style="max-width: 18%; flex-basis: 18%; padding-left: 6px !important;">Criado
      </v-flex>
    </v-layout>
    <!-- Lista de documentos -->
    <div v-for="(doc, idx) in documents" :key="doc.id" class="document-row">
      <!-- Layout Mini -->
      <v-layout v-if="mini"
        class="document-card document-row-layout mini-layout"
        :class="{'selected': isDocumentSelected(doc.id)}"
        :style="{
          borderLeft: '6px solid ' + getDocumentTypeColor(doc.document_type),
          boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
        }"
        justify-start
        align-center
        row
        wrap
        @click.stop="showDocument(doc)"
      >
        <v-flex class="mini-content px-2" grow>
          <v-tooltip bottom max-width="400">
            <template v-slot:activator="{ on }">
              <div class="mini-document-info" v-on="on">
                <div class="d-flex align-center">
                  <v-icon
                    size="20"
                    :color="documentStateColor(doc.document_state.enum)"
                    class="mr-2"
                  >
                    {{ documentStateIcon(doc.document_state.enum) }}
                  </v-icon>
                  <span class="document-type-name" :style="{ color: getDocumentTypeColor(doc.document_type) }">
                    {{ truncate(doc.document_type.name, {length: 50}) }}
                  </span>
                  <v-icon
                    v-if="documentPendingColor(doc) !== null"
                    :color="documentPendingColor(doc)"
                    size="12"
                    class="ml-2"
                  >
                    mdi-circle
                  </v-icon>
                </div>
                <div class="mini-docflow-number" v-if="doc.docflow_number">
                  <span :style="{ color: getDocumentTypeColor(doc.document_type) }">
                    {{ doc.docflow_number }}
                  </span>
                </div>
              </div>
            </template>
            <div class="tooltip-content">
              <p><strong>Tipo:</strong> {{ doc.document_type.name }}</p>
              <p v-if="doc.docflow_number"><strong>Número:</strong> {{ doc.docflow_number }}</p>
              <p><strong>Status:</strong> {{ doc.document_state.name }}</p>
              <p><strong>Criado por:</strong> {{ doc.created_by ? doc.created_by.name : 'N/A' }}</p>
              <p><strong>Setor:</strong> {{ doc.created_in ? (doc.created_in.abbreviation || doc.created_in.name) : 'N/A' }}</p>
              <p><strong>Data de criação:</strong> {{ doc.created_at | formatDateWithHours }}</p>
              <p v-if="doc.subject"><strong>Assunto:</strong> {{ doc.subject }}</p>
              <p v-if="doc.has_pending_revisions"><strong>Status:</strong> Possui revisões pendentes</p>
              <p v-if="doc.has_pending_signatures"><strong>Status:</strong> Possui assinaturas pendentes</p>
            </div>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- Layout Normal -->
      <v-layout v-else
        class="document-card document-row-layout"
        :class="{'mobile-card': $vuetify.breakpoint.smAndDown}"
        :style="{
          borderLeft: '6px solid ' + getDocumentTypeColor(doc.document_type),
          boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
        }"
        justify-start
        align-center
        row
        wrap
        @click.stop="showDocument(doc)"
      >
        <!-- Ordem -->
        <v-flex class="order-col text-left align-center px-3" xs1 xl1 style="max-width: 8%; flex-basis: 8%;">
          <v-avatar size="22" class="grey lighten-3 font-weight-bold">
            <span style="font-size: 12px">{{ idx + 1 }}</span>
          </v-avatar>
          <div class="d-inline-flex pa-1">
            <v-icon
              v-if="documentPendingColor(doc) !== null"
              :color="documentPendingColor(doc)"
              class="mini-dot"
            >
              mdi-circle
            </v-icon>
          </div>
        </v-flex>
        <!-- Documento -->
        <v-flex class="documento-container text-left" xs4 xl4 style="max-width: 35%; flex-basis: 35%;">
          <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on }">
              <div class="documento-layout" v-on="on" @click.stop> <!-- Adicionado @click.stop para impedir propagação -->
                <div class="documento-icon">
                  <v-icon
                    style="font-size: 24px !important;"
                    :color="documentStateColor(doc.document_state.enum)"
                  >
                    {{ documentStateIcon(doc.document_state.enum) }}
                  </v-icon>
                </div>
                <div class="documento-content">
                  <div class="documento-cabecalho">
                    <div
                      class="document-type-name"
                      :style="{ color: getDocumentTypeColor(doc.document_type), fontWeight: 500 }"
                    >
                      <span>{{ truncate(doc.document_type.name, {length: 100}) }}</span>
                    </div>
                  </div>
                  <div class="documento-rodape">
                    <div class="docflow-number-container" v-if="doc.docflow_number">
                      <span
                        :style="{ color: getDocumentTypeColor(doc.document_type), fontWeight: 500 }">
                        {{ doc.docflow_number }}
                      </span>
                      <v-btn icon x-small class="copy-button ml-1" @click.stop="copyToClipboard(doc.docflow_number)">
                        <v-icon size="14">mdi-content-copy</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="tooltip-content">
              <p><strong>Tipo:</strong> {{ doc.document_type.name }}</p>
              <p v-if="doc.docflow_number"><strong>Número:</strong> {{ doc.docflow_number }}</p>
              <p><strong>Status:</strong> {{ doc.document_state.name }}</p>
              <p><strong>Data de criação:</strong> {{ doc.created_at | formatDateWithHours }}</p>
              <p v-if="doc.subject"><strong>Assunto:</strong> {{ doc.subject }}</p>
            </div>
          </v-tooltip>
        </v-flex>
        <!-- Usuário -->
        <v-flex class="text-left align-center px-3" xs3 xl3 style="max-width: 22%; flex-basis: 22%;">
          <div class="entity-info" v-if="doc.created_by">
            <v-tooltip bottom max-width="500">
              <template v-slot:activator="{ on }">
                <v-chip class="entity-chip grey lighten-2" v-on="on">
                  <v-avatar v-if="doc.created_by.avatar && doc.created_by.avatar.url" size="24" class="mr-1">
                    <img :src="doc.created_by.avatar.url" alt="Avatar"/>
                  </v-avatar>
                  <v-avatar v-else size="24" class="mr-1">
                    <v-icon size="16" color="grey">mdi-briefcase</v-icon>
                  </v-avatar>
                  <span class="entity-name">{{ shortName(doc.created_by.name) }}</span>
                </v-chip>
              </template>
              <span class="entity-name">{{ shortName(doc.created_by.name) }}</span>
            </v-tooltip>
          </div>
        </v-flex>
        <!-- Setor criado -->
        <v-flex class="text-left align-center px-3" style="max-width: 17%; flex-basis: 17%;" xs2 xl2>
          <div class="document-info">
            <v-chip
              outline
              :style="{
                        color: getAdminUnitColor(doc.created_in),
                        borderColor: getAdminUnitColor(doc.created_in),
                        boxShadow: '0 1px 4px rgba(0,0,0,0.10)',
                        padding: '4px 12px',
                        fontWeight: 600
                      }"
              class="admin-unit-badge"
            >
              {{ doc.created_in.abbreviation || doc.created_in.name }}
            </v-chip>
          </div>
        </v-flex>
        <!-- Criado Em -->
        <v-flex class="text-left align-center px-3" style="max-width: 18%; flex-basis: 18%;" xs2 xl2>
          <v-layout justify-start align-center>
            <v-chip color="primary" outline>
              <v-icon v-if="doc.created_at" size="20" class="mr-2 mb-0">mdi-clock-fast</v-icon>
              <span class="grey--text text--darken-2 text-truncate">
                {{ doc.created_at | formatDateWithHours }}
              </span>
            </v-chip>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <document-dialog
      v-if="showDocumentDialog"
      :doc="selectedDocument"
      :showDocumentDialog="showDocumentDialog"
      @closeDocumentDialog="closeDocumentDialog"
    />
  </div>
</template>

<script>
import format from 'date-fns/format';
import * as ptLocale from 'date-fns/locale/pt';
import DocumentDialog from '@/components/document/show/DocumentDialog';
import DocumentInfo from '@/components/document/list/DocumentInfo';
import Highlighter from 'vue-highlight-words';
import {find, isEmpty, last, lowerCase, startCase, truncate} from 'lodash';
import bus from '@/utils/event-bus';
import acronym from '@/utils/acronym'
import CurrentOwner from "../../inbox/CurrentOwner.vue";
import shortName from "../../../utils/short-name";
import adminUnitHandling from '@/mixins/admin-unit-handling';
import getColorByText from '@/assets/utils/colorByText';
import {isUnlinkedDocument} from "../../../mixins/document-check";


export default {
  name: 'DocumentList',
  mixins: [adminUnitHandling],
  components: {
    CurrentOwner,
    DocumentDialog,
    Highlighter,
    DocumentInfo,
  },
  props: {
    documents: {
      default: [],
    },
    searchDocumentString: {
      type: String,
      default: '',
    },
    mini: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    bus.$on('onCloseDocumentDialog', () => {
      this.showDocumentDialog = false;
    });

    if (this.$router.currentRoute.query.documentId) {
      const document = this.documents.find(item =>
        item.id === Number(this.$router.currentRoute.query.documentId));
      this.showDocument(document);
    }
  },
  data() {
    return {
      documentSrc: {},
      headers: [
        {
          text: 'Ordem',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Documento',
          align: 'center',
          sortable: false
        },
        {
          text: 'Usuário',
          align: 'center',
          sortable: false
        },
        {
          text: 'Nº do Documento',
          align: 'center',
          sortable: false
        },
        {
          text: 'Criado',
          align: 'center',
          sortable: false,
        },
      ],
      presentationModeHeaders: [
        {
          text: 'Documentos',
          align: 'left',
          sortable: false,
        },
      ],
      pages: 0,
      showDocumentDialog: false,
      selectedDocument: {},
    };
  },
  methods: {
    getAdminUnitColor(unit) {
      if (!unit) return '#000000';
      return getColorByText(unit.name);
    },
    shortName,
    acronym,
    startCaseText(string) {
      return startCase(lowerCase(string));
    },
    last,
    truncate,
    formatDate(date) {
      if (date === new Date()) {
        return 'Hoje';
      }
      return format(date, `DD/MM/YYYY`, {locale: ptLocale});
    },
    documentStateIcon(state) {
      const statesIcon = {
        minute: 'mdi-file-compare',
        // minute_draft: 'mdi-file-document-edit',
        document_docgo: 'mdi-file-document',
        draft: 'mdi-file-hidden',
        minute_draft: 'mdi-file-hidden',
        unlinked: 'mdi-link-variant-off',
        document_attached: 'mdi-file-document-outline',
        import: 'mdi-file-import',
        temp: 'mdi-file-document-outline',
      };
      return statesIcon[state];
    },
    documentPendingColor(item) {
      if (item.has_pending_revisions) {
        return 'amber';
      } else if (item.has_pending_signatures) {
        return 'accent';
      }
      return null;
    },
    showDocument(doc) {
      if (isUnlinkedDocument(doc)) {
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          color: 'error',
          message: 'Esse documento foi desvinculado e não pode ser aberto.',
          button: {show: true, text: 'Fechar', message: ''},
          timeout: 6000,
          messageIcon: 'mdi-alert-outline',
        });

        return;
      }

      this.selectedDocument = {...doc};
      if (this.folderViewMode !== 'presentation') {
        this.showDocumentDialog = true;
      } else {
        bus.$emit('load-pdf', last(doc.document_versions).file);
      }
    },
    closeDocumentDialog() {
      this.showDocumentDialog = false;
    },
    isDocumentSelected(docId) {
      return !isEmpty(this.selectedDocument)
        && this.selectedDocument.id === docId && this.folderViewMode === 'presentation';
    },
    getDocumentTypeColor(documentType) {
      if (!documentType) return '#000000';
      return getColorByText(documentType.name);
    },
    documentStateColor(state) {
      const statesColor = {
        document_attached: '#4CAF50',
        document_docgo: '#2196F3',
        draft: '#757575',
        minute: '#FFA000',
        minute_draft: '#757575',
        unlinked: '#F44336',
        import: '#9C27B0',
        temp: '#FF9800',
      };
      return statesColor[state] || '#757575';
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          timeout: 2000,
          color: 'success',
          message: 'Processo copiado para a área de transferência',
          messageIcon: 'mdi-check',
        });
      }).catch(() => {
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          timeout: 2000,
          color: 'error',
          message: 'Erro ao copiar o Processo',
          messageIcon: 'mdi-close',
        });
      });
    },
  },
  computed: {
    keywords() {
      if (this.searchDocumentString === '') {
        return [];
      }
      return this.searchDocumentString.split(' ');
    },
    folderViewMode() {
      return this.$store.getters.folderViewMode;
    },
  },
  watch: {
    documents(val) {
      if (!isEmpty(this.selectedDocument)) {
        this.selectedDocument = find(val, ['id', this.selectedDocument.id]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Ajustar chip da coluna "Criado" */
.criado {
  .v-chip {
    max-width: 100%;
    overflow: hidden;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: calc(100% - 28px); /* Para o ícone */
    }
  }
}

.px-3 {
  //padding-left: 6px !important;
  //padding-right: 6px !important;
  padding: 6px 6px !important;
}

.document-list-header {
  color: #757575;
  background: #f1f4f8;
  margin-bottom: 4px;
  padding-left: 2px; /* Adicionar padding esquerdo no cabeçalho */

  .ordem {
    max-width: 8% !important;
    flex-basis: 8% !important;
    padding-left: 6px !important; /* Mesmo padding das células */
  }

  .documento {
    max-width: 35% !important;
    flex-basis: 35% !important;
    padding-left: 6px !important;
  }

  .usuario {
    max-width: 22% !important;
    flex-basis: 22% !important;
    padding-left: 6px !important;
  }

  .numero {
    max-width: 17% !important;
    flex-basis: 17% !important;
    padding-left: 6px !important;
  }

  .criado {
    max-width: 18% !important;
    flex-basis: 18% !important;
    padding-left: 6px !important;
  }
}

.header-col {
  padding: 8px 6px 8px 6px !important; /* Padronizar o padding */
  font-size: 12px;
  letter-spacing: 0.2px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-col {
  padding: 4px 6px 4px 4px;
  font-size: 12px;
  letter-spacing: 0.2px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.documento-container {
  display: flex;
  flex-direction: column;
  padding: 4px 6px;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;

  .docflow-number-container {
    display: flex;
    align-items: center;
    height: 8px; /* Altura fixa menor */
    font-size: 11px;

    span {
      font-size: 11px;
      color: #757575;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      cursor: default;
    }

    .copy-button {
      margin-top: -2px !important; /* Ajuste vertical fino */
      height: 16px !important;
      width: 16px !important;

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }

      .v-icon {
        color: #757575;
      }
    }

    &:hover {
      .copy-button {
        opacity: 1;
      }
    }
  }

  .documento-layout {
    &:hover {
      cursor: default;
    }
  }
}

.documento-layout {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.documento-icon {
  display: flex;
  align-items: center;
  padding-right: 8px;
  flex-shrink: 0;
}

.documento-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  cursor: default !important;
  font-size: 14px !important;

  .documento-cabecalho {
    display: flex;
    flex-direction: row;
    //margin-bottom: 2px;
    width: 90%;
    cursor: default !important;

    .document-type-name {
      margin-top: 0;
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.3; /* Aumentado o line-height */
      font-size: 12px !important;
    }
  }
  .documento-rodape {
    width: 100%;
    margin-top: 6px; /* Aumentado a margem superior */
    cursor: default !important;

    .document-container {
      margin-bottom: 8px; /* Adicionado margem inferior */
    }

    .admin-unit-badge {
      //margin-top: 8px !important; /* Aumentado a margem superior do badge */
    }
    span {
      font-size: 11px;
      color: #757575;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      cursor: default;
      height: 22px;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      //padding: 0 8px;
      //white-space: nowrap;
    }
  }
}

/* Remover duplicação */
.document-row-layout {
  margin-bottom: 2px;
  border-radius: 3px;
  background: #fff;
  min-height: 28px;
  box-sizing: border-box;
  padding: 2px;
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer; /* Cursor pointer para o card inteiro */
}

.document-row {
  margin-bottom: 1px;
}

.order-col, .document-icon-col, .user-info, .document-type-name, .status-badge {
  font-size: 12px !important;
  line-height: 2.2 !important;
}

.v-avatar {
  width: 18px !important;
  height: 18px !important;
  font-size: 11px !important;
}

.v-icon {
  font-size: 18px !important;
}

.v-chip, .user-chip, .docflow-badge {
  height: 18px !important;
  min-height: 18px !important;
  font-size: 11px !important;
  padding: 12px 6px !important;
  margin: 0 2px 0 0 !important;
}

.admin-unit-badge {
  font-size: 11px !important;
  padding: 10px 8px !important;
  height: 18px !important;
  min-height: 18px !important;
  text-transform: uppercase !important;
}

.document-type-name {
  margin-top: 2px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px !important;
}

.status-badge {
  margin-left: 0;
  font-size: 11px !important;
  padding: 6px 6px !important;
  height: 18px !important;
  min-height: 18px !important;
}

.tooltip-content {
  text-align: left;

  p {
    margin: 4px 0;
    font-size: 12px;
    line-height: 1.4;
  }

  strong {
    font-weight: 600;
    color: #e8dada;
  }
}

/* Adicione esse CSS para permitir quebra de linha nas colunas */
/* Adicione este código ao seu CSS existente */
/* Correção das regras de cursor */
.document-card {
  transition: all 0.2s ease-in-out;
  cursor: pointer !important; /* Força cursor pointer para todo o card */

  &:hover {
    transform: translateY(-1px); /* Leve movimento para cima */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important; /* Sombra mais pronunciada */
    background-color: #f9fafc; /* Cor de fundo suave ao passar o mouse */
  }

  /* Coluna de documento com cursor default */
  .documento-container {
    cursor: default !important;

    /* Todos os elementos dentro da coluna documento */
    .documento-layout,
    .documento-icon,
    .documento-content,
    .documento-cabecalho,
    .documento-rodape {
      cursor: default !important;
    }

    /* Todos os textos dentro */
    span, div:not(.copy-button) {
      cursor: default !important;
    }
  }

  /* Botão de cópia mantém cursor pointer */
  .copy-button {
    cursor: pointer !important;

    .v-icon {
      cursor: pointer !important;
    }
  }
}

/* Remover as regras conflitantes */
.documento-layout {
  display: flex;
  flex-direction: row;
  width: 100%;
  /* Removido cursor pointer daqui */
}

/* Manter fora do escopo .document-card para evitar sobreposição */
.documento-container {
  display: flex;
  flex-direction: column;
  padding: 4px 6px;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  /* Removido cursor pointer daqui */
}

/* Remover cursor pointer quando estiver em dispositivos móveis */
/* Ajuste para garantir que as colunas reais também aplicam wrap em resoluções médias */
@media (min-width: 961px) and (max-width: 1264px) {
  .document-card {
    flex-wrap: wrap !important;

    /* Ajuste das larguras no card para corresponder ao cabeçalho */
    .order-col {
      max-width: 8% !important;
      flex-basis: 8% !important;
    }

    .documento-container {
      max-width: 45% !important;
      flex-basis: 45% !important;
    }

    .align-center[style*="max-width: 22%"] {
      max-width: 47% !important;
      flex-basis: 47% !important;
    }

    .align-center[style*="max-width: 17%"],
    .align-center[style*="max-width: 18%"] {
      max-width: 50% !important;
      flex-basis: 50% !important;
    }
  }

  /* Ajuste para o segundo "row" das colunas */
  .document-card .align-center[style*="max-width: 17%"],
  .document-card .align-center[style*="max-width: 18%"] {
    margin-top: 4px;
  }
}

/* Para telas pequenas, reorganizar completamente o layout */
@media (max-width: 960px) {
  .document-card {
    flex-direction: column !important;

    & > * {
      max-width: 100% !important;
      flex-basis: 100% !important;
      margin-bottom: 4px;
    }

    .order-col {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .documento-container {
      order: 0;
    }

    .order-col {
      order: -1;
    }
  }
}

/* Ajuste no cabeçalho para quebrar também */
.document-list-header {
  @media (max-width: 960px) {
    display: none; /* Opção 1: ocultar o cabeçalho em telas pequenas */
  }

  @media (min-width: 961px) and (max-width: 1264px) {
    flex-wrap: wrap !important;

    .ordem {
      max-width: 8% !important;
      flex-basis: 8% !important;
    }

    .documento {
      max-width: 45% !important;
      flex-basis: 45% !important;
    }

    .usuario {
      max-width: 47% !important;
      flex-basis: 47% !important;
    }

    .numero, .criado {
      max-width: 50% !important;
      flex-basis: 50% !important;
    }
  }
}

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 0;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-cascade-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateY(0);
}

.fade-cascade-enter {
  opacity: 0;
  transform: translateY(20px);
}

.fade-cascade-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.cascade-group > * {
  transition-delay: var(--cascade-delay, 0s);
  opacity: 1;
}

.mini-dot {
  font-size: 9px !important;
  height: 9px !important;
  width: 9px !important;
  margin-left: 4px !important;
  vertical-align: middle !important;
}

.entity-info {
  width: 90%;

  .entity-chip {
    height: auto;
    padding: 4px 8px;
    cursor: pointer;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    width: 100%;
    transition: all 0.3s ease;
    will-change: transform;

    .v-avatar {
      flex: 0 0 auto;
      margin-right: 4px;
      transition: transform 0.3s ease;
    }

    .entity-name {
      max-width: 250px !important;
      white-space: nowrap !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      -webkit-line-clamp: 2 !important;
      -webkit-box-orient: vertical !important;
    }
  }
}

/* Mini Mode Styles */
.mini-layout {
  padding: 8px 4px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }

  &.selected {
    background-color: rgba(33, 150, 243, 0.05);
  }
}

.mini-content {
  .mini-document-info {
    .document-type-name {
      font-size: 13px;
      font-weight: 500;
      line-height: 1.2;
    }
  }

  .mini-docflow-number {
    font-size: 11px;
    margin-top: 2px;
    margin-left: 28px; // Aligns with the text above (icon width + margin)
  }
}

.tooltip-content {
  p {
    margin: 0;
    padding: 2px 0;
    font-size: 12px;
    line-height: 1.4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/document/list/DocumentList.vue